import bsModal from 'bootstrap/js/dist/modal';

export default {
  install: (app, options) => {
    const modals = [];

    const show = (id, options = { backdrop: 'static', focus: true, keyboard: true }, callback_route) => {
      const modalEl = document.getElementById(id);
      const modalIndex = modals.findIndex(element => element.id == id);

      if (modalIndex === -1) {
        const modalObject = new bsModal(modalEl, options);

        modals.push({
          'id': id,
          'object': modalObject
        });

        modalObject.show();
      } else {
        modals[modalIndex].object.show();
      }
    };

    const hide = id => {
      const modalIndex = modals.findIndex(element => element.id == id);
      modals[modalIndex].object.hide();
    }

    const modal = { modals, show, hide };

    app.config.globalProperties.$modal = modal;
    app.provide('$modal', modal);
  }
}